import React from "react";

import type { JobFilterLocation } from "@js/apps/filters/types";

import type { JobFilters } from "../../filters";
import { getFiltersToSave } from "../helpers";
import { SaveFiltersModalInstance } from "../save-filters-modal";
import { SaveSearchButton } from "../save-search-button";
import { SavedFilterTitle } from "../saved-filter-title";

import { openSaveJobsFiltersModal } from "./save-jobs-filters-modal";

type SaveJobsFiltersProps = {
  filters: Partial<JobFilters>;
  savedFilterName?: string | null;
  location: JobFilterLocation;
};

export const SaveJobsFilters = ({
  filters,
  savedFilterName,
  location,
}: SaveJobsFiltersProps) => {
  return (
    <>
      {savedFilterName ? (
        <SavedFilterTitle title={savedFilterName} />
      ) : (
        <SaveSearchButton
          onClick={() => {
            const filtersToSave = getFiltersToSave(filters);
            openSaveJobsFiltersModal({
              filters: filtersToSave,
              location: location,
            });
          }}
        />
      )}
      <SaveFiltersModalInstance />
    </>
  );
};
